// =============================================================
// LANDING PAGE — composition only (mimari plan)
// "LandingPage.tsx composes sections only; it does not contain animation implementation."
// =============================================================

import { Nav } from "@/components/layout/Nav";
import { Footer } from "@/components/layout/Footer";
import { SkipLink } from "@/components/ui/SkipLink";
import { ScrollProgressRail } from "@/components/ui/ScrollProgressRail";
import { Safak } from "./sections/Safak/Safak";
import { Hazirlik } from "./sections/Hazirlik/Hazirlik";
import { Sofra } from "./sections/Sofra/Sofra";
import { SponsorBanner } from "./components/SponsorBanner";
import { Servis } from "./sections/Servis/Servis";
import { Ani } from "./sections/Ani/Ani";
import { Yanki } from "./sections/Yanki/Yanki";
import { Kapi } from "./sections/Kapi/Kapi";

export function LandingPage() {
  return (
    <>
      <SkipLink target="#main" label="İçeriğe geç" />
      <ScrollProgressRail />
      <Nav.Root />

      <main id="main" tabIndex={-1}>
        <Safak />
        <Hazirlik />
        <Sofra />
        <SponsorBanner />
        <Servis />
        <Ani />
        <Yanki />
        <Kapi />
      </main>

      <Footer.Root />
    </>
  );
}